<template>
  <div>
    <div v-if="!isFreightBill" class="newcardblock">
      <div class="row labelgrid" v-if="isDedicatedTruck">
        <div class="col-6 no-padding">
          <div class="primarylabel">
            <span>{{ $t('EXTRA_KMS_TRAVELLED') }}</span>
          </div>
        </div>
        <div class="col-6 floatright no-padding">
          <div class="divcardblock">
             <div class="sectext_bold" v-if="!editable && !reSubmit">
              {{extraKmValue}}
            </div>
            <input type="number" placeholder="Enter Extra KMs"
              v-model="extraKmValue" @keyup="updateExtraKm" @input="input"
              @wheel="$event.target.blur()"
              @keydown="preventDefault($event)" v-else>
          </div>
        </div>
      </div>
      <div class="row labelgrid">
        <div class="col-6 no-padding">
          <div class="primarylabel">
            <span v-if=" (( this.payEarly && this.discountAmount ) ||
             (checkStaticDiscount))"  >
              {{ $t('TOTAL_BASE_VALUE') }}</span>
              <span v-else-if="isTaxable">
                {{ $t('TOTAL_TAXABLE_VALUE') }}</span>
            <span v-else>Total Amount</span>
          </div>
        </div>
        <div class="col-6 no-padding floatright">
          <div class="valuesucess">{{$getIndianFormat(totalAmountValue)}}</div>
        </div>
      </div>
      <div v-if="(editable||(invoiceStatusValue===invoiceStatus.RETURNED)) && enableBillDiscount" class="gridholder">
      <div class="row labelgrid">
        <div class="col-6 no-padding">
          <div class="primarylabel boldText">
            <span>{{ $t('PAY_EARLY') }}</span>
          </div>
        </div>
        <div class="col-6 floatright">
          <SwitchBtn v-if="!payEarlyDisabled" v-model="payEarly" :disabled="payEarlyDisabled" style="display:block" size="small" active-text="Yes" inactive-text="No"
          class="switch-light" @change="toggleMenu">
          </SwitchBtn>
          <Tooltip v-else class="item" effect="dark" placement="bottom">
          <div slot="content" class="tooltipcontent">
            <span class="errormessagetext" v-if="payEarlyDisabled">
                  <svgicon name="warning" class="icon" width="10" height="10" :original="true" />
                  {{ $t('PAY_MSME_RANGE_ERROR_MESSAGE') }}
            </span>
          </div>
          <SwitchBtn :disabled="payEarlyDisabled" style="display:block" size="small" active-text="Yes" inactive-text="No"
          class="switch-light">
            </SwitchBtn>
        </Tooltip>
        </div>
      </div>
      <div v-if="payEarly">
      <div class="row labelgrid">
        <div class="col-5 no-padding">
          <div class="primarylabel">
            <div>{{ $t('PAY_BY_DATE') }} <span class="asterisk">*</span></div>
          </div>
        </div>
        <div class="col-7 floatright no-padding">
          <span>
                  <div class="datepickerblock calenderstyle calender-dark">
                    <div class="datepicker-trigger">
                      <span id="datepicker-trigger-2" class="text-white"  v-if="payByDate">
                        {{ displayDate(payByDate) }}
                      </span>
                      <span id="datepicker-trigger-2" class="text-white"  v-else>
                        Select pay date
                      </span>
                      <!-- <input type="text" id="datepicker-trigger-2" class="text-white" autocomplete="off"
                        :placeholder="'Select pay date'"
                        :value="displayDate(payByDate)"
                        :disabled="!isValiddate"
                        @keydown = "preventDefault($event)"
                        @keyup = "preventDefault($event)"/> -->
                      <span class="errormessagetext" v-if="(clickedSubmit || clickedReSubmit) && payEarly && !payByDate">
                        <svgicon name="warning" class="icon" width="10" height="10" :original="true" />
                          {{ $t('PAY_BY_DATE_REQUIRED') }}
                      </span>
                      <span v-if="isValiddate">
                        <AirbnbStyleDatepicker
                          :trigger-element-id="'datepicker-trigger-2'"
                          :mode="'single'" :months-to-show="1" :date-one="payByDate"
                          :minDate="pastDay"
                          :endDate="futureDay"
                          @date-one-selected="val => {payByDate = val;calculateMininumDiscount();$emit('updateValue', 'payByDate', val)}"
                          />
                        <svgicon name="fill_arrow" class="icon" width="10" height="10"
                        :original="true" />
                      </span>
                      <span class="errormessagetext" v-if="(new Date(payByDate) < pastDay) || (new Date(payByDate) > futureDay)">
                        <svgicon name="warning" class="icon" width="10" height="10" :original="true" />
                          {{ $t('PAY_BY_DATE_RANGE') }}
                      </span>

                    </div>
                  </div>
              </span>
        </div>
      </div>
      <div class="row labelgrid">
        <div class="col-6 no-padding">
          <div class="primarylabel">{{ $t('DISCOUNT_AMOUNT') }} <span class="asterisk">*</span></div>
        </div>
        <div class="col-6 floatright no-padding">
          <div class="divcardblock" :class="{'errorfield': (clickedSubmit || clickedReSubmit) && payEarly && !discountAmount}">
            <input type="number" placeholder="Enter Discount"
              v-model.number="discountAmount" @input="valuesChanged($event)"
              :disabled="!payByDate || !isValiddate"
              @keydown="preventDefault($event)"
              @keyup="preventDefault($event)"
              >
            <span class="errormessagetext" v-if="(clickedSubmit || clickedReSubmit) && payEarly && !discountAmount">
              <svgicon name="warning" class="icon" width="10" height="10" :original="true" />
              {{ $t('PAY_DISCOUNT_AMOUNT_REQUIRED') }}
            </span>
            <span class="errormessagetext" v-if="discountAmount >= totalAmountValue">
              <svgicon name="warning" class="icon" width="10" height="10" :original="true" />
                {{ $t('PAY_GREATER_DISCOUNT_AMOUNT') }}
            </span>
            <span class="errormessagetext" v-if="discountAmount && (discountAmount < minDiscountAmount)">
              <svgicon name="warning" class="icon" width="10" height="10" :original="true" />
                {{ $t('PAY_INVALID_DISCOUNT_AMOUNT') }}
            </span>
          </div>
        </div>
      </div>
      <div class="row labelgrid">
        <div class="col-6 no-padding">
        </div>
        <div class="col-6 floatright">
          <div v-if="discountAmount && (discountAmount < totalAmountValue)" class="valuesucess">{{$getIndianFormat(totalAmountValue-discountAmount)}}</div>
        </div>
      </div>
      </div>
      </div>
      <div v-if="showDiscountFields">
      <div class="row labelgrid">
        <div class="col-6 no-padding">
          <div class="primarylabel">{{ $t('DISCOUNT_AMOUNT') }}</div>
        </div>
        <div class="col-6 floatright">
           <div class="valuesucess">{{$getIndianFormat(discountAmount)}}</div>
        </div>
      </div>
      <div class="row labelgrid">
        <div class="col-6 no-padding" v-if=" (( this.payEarly && this.discountAmount ) ||
          (checkStaticDiscount))"  >
          <div class="primarylabel">{{ $t('TOTAL_TAXABLE_VALUE') }}</div>
        </div>
        <div class="col-6 no-padding" v-else-if="discountAmount">
          <div class="primarylabel">{{ $t('TOTAL_AMOUNT_DISCOUNTED') }}</div>
        </div>
        <div class="col-6 floatright">
           <div class="valuesucess">{{$getIndianFormat(totalAmountValue-discountAmount)}}</div>
        </div>
      </div>
      </div>
      <div class="row labelgrid" v-for="additionalCharge in invoiceCharges.additionalCharges"
        :key="additionalCharge.label">
        <div class="col-6 no-padding">
          <div class="primarylabel">
            {{ `${additionalCharge.label} (${additionalCharge.percentage}%)`}}
          </div>
        </div>
        <div class="col-6 no-padding floatright">
          <div class="valuesucess">{{ additionalCharge.amount }}</div>
        </div>
      </div>
      <div>
      <div v-if=" (( (this.payEarly && this.discountAmount )) ||
        (checkStaticDiscount))" >
      <div class="row labelgrid" v-for="additionalCharge in invoiceCharges.additionalCharges"
        :key="additionalCharge.label">
      <div class="col-6 no-padding ">
          <div class="primarylabel">
              <span >
              {{ $t('TOTAL_TAXABLE_VALUE') }}</span>
          </div>
        </div>
        <div class="col-6 floatright no-padding">
          <div class="valuesucess" v-if="totalAmountValue >= 0">
            {{$getIndianFormat(totalAmountValue - additionalCharge.amount)}}
          </div>
          <div class="valuesucess" v-else> 0 </div>
        </div>
      </div>
    </div>
  </div>
      <div class="row labelgrid">
        <div class="col-6 no-padding">
          <div class="seclabel">{{ $t('SERVICE_PROVIDER_STATE') }} <span class="asterisk">*</span></div>
        </div>
        <div class="col-6 no-padding floatright">
          <div class="bgcolor secdropdown text-ellipsis">
          <Select :value="serviceProviderState" placeholder="Select" popper-class="bgdropdown"
            @change="updateGstNumberFromList($event)"
            v-if="stateList.length > 1 && editable">
              <Option
                v-for="state in stateList"
                :key="state.name"
                :label="state.name"
                :value="state.name"
                >
              </Option>
            </Select>
            <div class="sectext_bold col-15 no-padding floatright" v-else>{{ serviceProviderState }}</div>
            <span class="errormessagetext" v-if="clickedSubmit && !serviceProviderState">
              <svgicon name="warning" class="icon" width="10" height="10" :original="true" />
              {{ $t('PAY_SERVICE_PROVIDER_REQUIRED') }}
            </span>
          </div>
        </div>
      </div>
      <div class="row labelgrid">
        <div class="col-6 no-padding">
          <div class="primarylabel">{{ $t('GSTIN') }} <span class="asterisk">*</span></div>
        </div>
        <div class="col-6 floatright no-padding">
          <div class="divcardblock" :class="{'errorfield': clickedSubmit && !isValidGst}">
            <div class="sectext_bold no-padding floatright" v-if="!(gstinEditable || editable)">
              {{ gstNumber }}
            </div>
            <input type="text" placeholder="Enter GSTIN Number"
              :value="gstNumber" @input="$emit('updateValue','gstNumber',$event.target.value)"
              @keydown="preventDefault($event)"
              @keyup="preventDefault($event)"
              v-else>
            <span class="errormessagetext" v-if="clickedSubmit && !isValidGst">
              <svgicon name="warning" class="icon" width="10" height="10" :original="true" />
              {{ $t('PAY_GSTIN_REQUIRED') }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="gstAckNo && gstAckNo!==''" class="row labelgrid">
        <div class="col-6 no-padding ">
          <div class="primarylabel">{{ $t('ACK_NO') }}</div>
        </div>
        <div class="col-6 no-padding floatright ">
          <div class="divcardblock">
            <div class="sectext_bold no-padding floatright">
              {{ gstAckNo }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="gstAckDate && gstAckDate!==''" class="row labelgrid">
        <div class="col-6 no-padding">
          <div class="primarylabel">{{ $t('ACK_DATE') }}</div>
        </div>
        <div class="col-6 floatright no-padding">
          <div class="divcardblock">
            <div class="sectext_bold no-padding floatright">
              {{ displayDate(gstAckDate) }}
            </div>
          </div>
        </div>
      </div>
      <span v-if="isTaxable">
      <div class="row labelgrid">
        <div class="col-6 no-padding">
          <div class="primarylabel">{{ $t('GST_METHOD') }}</div>
        </div>
        <div class="col-6 no-padding floatright">
          <div class="bgcolor secdropdown">
          <Select :value="gstType" placeholder="Select" popper-class="bgdropdown"
            @change="val => $emit('updateValue','gstType', val)"
            v-if="editable && !isGstTypeConfigExist">
              <Option
                v-for="type in gstTypes"
                v-if="!type.hidden"
                :key="type.value"
                :label="`${type.label}`"
                :value="type.value"
                >
              </Option>
            </Select>
            <div class="sectext_bold no-padding floatright" v-else>{{ gstTypeString }}</div>
          </div>
          <div class="bgcolor secdropdown" v-if="isForwardGstSelected && !isDefaultIgstExist">
            <Select :value="igst" placeholder="Select" popper-class="bgdropdown"
              @change="val => $emit('updateValue','igst', val)" v-if="editable">
                <Option
                v-for="gst in gstPercentageList"
                :key="gst"
                :label="`${gst}%`"
                :value="gst"
                >
              </Option>
            </Select>
          </div>
        </div>
      </div>
      <div v-if="isForwardGstSelected">
        <div class="row labelgrid">
          <div class="col-6 no-padding">
            <div class="primarylabel">{{ $t('TAX') }}</div>
          </div>
          <div class="col-6 floatright">
            <div class="sectext_bold"></div>
          </div>
        </div>
        <div class="row labelgrid" v-if="isIntraState">
          <!-- <div class="col-6 no-padding" v-if="canEditIgst">
            <div class="seclabel bgcolor secdropdown">
              {{ $t('CGST') }}
              <span style="position: relative;
                right: 105px;
                bottom: 19px;">
                <Select popper-class="bgdropdown"
                  :value="igst / 2"
                  :disabled="disableUpdateGST"
                  @change="updateGst('cgst', $event)">
                  <Option
                    v-for="item in cGSTList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </Option>
                </Select>
              </span>
            </div>
          </div> -->
          <div class="col-6 no-padding">
            <div class="seclabel">{{ $t('CGST') }} ({{ igst / 2 }}%)</div>
          </div>
          <div class="col-6 floatright">
            <div class="valuesucess">{{$getIndianFormat(invoiceCharges.cgstTaxAmount)}}</div>
          </div>
        </div>
        <div class="row labelgrid" v-if="isIntraState">
          <div class="col-6 no-padding">
            <div class="seclabel">{{ isUnionTerritory ? 'UGST' : $t('SGST') }} ({{ igst / 2 }}%)</div>
          </div>
          <div class="col-6 floatright">
            <div class="valuesucess">{{$getIndianFormat(invoiceCharges.sgstTaxAmount)}}</div>
          </div>
        </div>
        <div :class="{row: true, labelgrid: true}" v-if="!isIntraState">
          <!-- <div class="col-6 no-padding" v-if="canEditIgst" style="display: flex;">
            <div class="seclabel bgcolor secdropdown">
              {{ $t('IGST') }}
              <span style="position: relative;
                right: 89px;
                bottom: 19px;">
                <Select popper-class="bgdropdown"
                  :value="igst"
                  :disabled="disableUpdateGST"
                  @change="updateGst('igst', $event)">
                  <Option
                    v-for="item in iGSTList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </Option>
                </Select>
              </span>
            </div>
          </div> -->
          <div class="col-6 no-padding">
            <div class="seclabel">{{ $t('IGST') }} ({{ igst }}%)</div>
          </div>
          <div class="col-6 floatright">
            <div class="valuesucess">{{$getIndianFormat(invoiceCharges.igstTaxAmount)}}</div>
          </div>
        </div>
      </div>
      </span>
    </div>
    <div class="collapse-slider-header" :class="{ 'arrow-active': showOtherInfoSlider }" v-if="isEditableCustomFields" @click="$emit('openOtherInfoSlider')">
      <div> OTHER INFORMATION </div>
      <svgicon
        class="arrow-indicator"
        :name="!showOtherInfoSlider ? 'icon-accordion-arrow-right' : 'icon-accordion-arrow-left'"
        width="20"
        height="20"
        :original="true" />
    </div>
    <div class="bgfooter">
      <div class="row no-margin">
        <div class="col-6 no-padding">
          <div>{{ $t('TOTAL_INVOICE_VALUE') }}</div>
        </div>
        <div class="col-6 floatright">
          <svgicon name="rupee" class="icon" width="13" height="13" :original="true" />
          {{$getIndianFormat(Number(getTotalCharges.toFixed(2)))}}
        </div>
      </div>
      <p class="wordlabel">{{$getWords(Number(getTotalCharges.toFixed(2)))}}</p>
    </div>
    <div class="trianglebg"></div>
  </diV>
</template>
<script>
import { mapGetters } from 'vuex';
import debounce from 'debounce';
import moment from 'moment';
import states from '@/constants/india-states';
import { gstType, gstTypes } from 'pando-constants';
import { formatDisplaySingleDate, formatDisplayDate } from '@/lib/Date';
import { invoiceStatus } from '@/constants/payments';

export default {
  props: {
    isInvoice: {
      type: Boolean,
      default: () => false,
    },
    indentDetails: {
      type: Array,
      required: true,
      default: () => [],
    },
    invoiceStatusValue: {
      type: Number,
      default: 0,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    igst: {
      type: Number,
      default: 0,
    },
    invoiceCharges: {
      type: Object,
    },
    isIntraState: {
      type: Boolean,
      default: false,
    },
    isUnionTerritory: {
      type: Boolean,
      default: false,
    },
    serviceProviderState: {
      type: String,
      default: '',
    },
    totalAmountValue: {
      type: Number,
      required: false,
    },
    discount: {
      type: Number,
      default: null,
    },
    paymentDueDate: {
      type: String,
      default: '',
    },
    gstType: {
      type: Number,
      default: 1,
    },
    gstNumber: {
      type: String,
      default: '',
    },
    gstAckNo: {
      type: String,
      default: '',
    },
    gstAckDate: {
      default: '',
    },
    gstPercentageList: {
      type: Array,
    },
    isTaxable: {
      type: Boolean,
    },
    clickedSubmit: {
      type: Boolean,
    },
    clickedReSubmit: {
      type: Boolean,
    },
    isGstTypeConfigExist: {
      type: Boolean,
    },
    isDefaultIgstExist: {
      type: Boolean,
    },
    extraKm: {
      type: Number,
    },
    isDedicatedTruck: {
      type: Boolean,
    },
    reSubmit: {
      type: Boolean,
      default: false,
    },
    isFreightBill: {
      type: Boolean,
      default: false,
    },
    gstinEditable: {
      type: Boolean,
      default: false,
    },
    billDiscountingConfig: {
      type: Object,
    },
    isValiddate: {
      type: Boolean,
      default: true,
    },
    isEditableCustomFields: {
      type: Boolean,
      default: false,
    },
    showOtherInfoSlider: {
      type: Boolean,
      default: false,
    },
    disableUpdateGST: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      gstTypes,
      payEarly: !!this.discount,
      payEarlyDisabled: false,
      invoiceStatus,
      futureDay: '',
      pastDay: '',
      discountAmount: this.discount || null,
      payByDate: this.paymentDueDate,
      minDiscountAmount: null,

      // this is a temporary fix for a prod bug (PAN-37854), Will be reverted
      // iGSTList: [{ value: 12, label: '12%' }, { value: 18, label: '18%' }],
      // cGSTList: [{ value: 6, label: '6%' }, { value: 9, label: '9%' }],
    };
  },
  created() {
    if (!this.isDedicatedTruck) {
      this.$emit('updateExtraKm', this.extraKm);
    }
    if (this.stateList.length === 1 && this.gstNumbers.length === 1) {
      const gst = this.gstNumbers[0];
      if (gst.gst_type != null) {
        this.$emit('updateValue', 'gstType', gst.gst_type);
      }
      if (gst.gst_percentage != null) {
        this.$emit('updateValue', 'igst', gst.gst_percentage);
      }
    }
    if (this.discountAmount) {
      this.$emit('updateValue', 'payEarly', true);
      this.$emit('updateValue', 'discountAmount', this.discountAmount);
    }
    // finding the minimum dates from all the reported dates
    const processingTime = (this.billDiscountingConfig && this.billDiscountingConfig.invoice_processing_time) || 0;
    this.pastDay = moment().add(processingTime - 1, 'days').toDate();
    const futureDate = this.currentTransporter.credit_period ?
      moment().add(this.currentTransporter.credit_period - 1, 'days').toDate() : '';
    if (this.currentTransporter.is_msme) {
      const allReportedDates = this.indentDetails.map(indent => new Date(indent.reported_date));
      const earliestReportedDate = new Date(Math.min(...allReportedDates));
      const paymentDueDate = new Date(earliestReportedDate.setDate(earliestReportedDate.getDate() + this.currentTransporter.credit_period));

      this.futureDay = (futureDate < paymentDueDate) ? futureDate : paymentDueDate;
      if (new Date(this.futureDay) < new Date(this.pastDay)) {
        // disable the button
        this.payEarlyDisabled = true;
      }
    } else {
      this.futureDay = futureDate;
    }
  },
  computed: {
    ...mapGetters({
      currentTransporter: 'app/currentTransporter',
      totalAmountValue: 'paymentsV2/totalTransporterCharges',
    }),
    // canEditIgst() {
    //   return this.$hasFeature('edit_invoice_igst') &&
    //     (
    //       this.reSubmit ||
    //       (this.editable && !this.isInvoice)
    //     );
    // },
    enableBillDiscount() {
      return this.billDiscountingConfig && this.billDiscountingConfig.is_enabled && this.billDiscountingConfig.invoice_lower_limit && this.totalAmountValue >= this.billDiscountingConfig.invoice_lower_limit;
    },
    showDiscountFields() {
      return this.discountAmount && ![this.invoiceStatus.RETURNED, 0].includes(this.invoiceStatusValue);
    },
    gstNumbers() {
      if (this.currentTransporter.gst_number && this.currentTransporter.gst_number.length) {
        const gstNumbersList = this.currentTransporter.gst_number.map(gst =>
          Object.assign({ name: gst.state, number: gst.number, ack_no: gst.ack_no, ack_date: gst.ack_date, gst_type: gst.gst_type, gst_percentage: gst.percentage }));
        return gstNumbersList;
      }
      return [];
    },
    stateList() {
      if (this.gstNumbers && this.gstNumbers.length) {
        return this.gstNumbers;
      }
      return states;
    },
    isForwardGstSelected() {
      return this.gstType === gstType.FCM;
    },
    isReverseGstSelected() {
      return this.gstType === gstType.RCM;
    },
    gstTypeString() {
      return this.gstType === gstType.FCM ? 'FORWARD' : 'REVERSE';
    },
    extraKmValue() {
      return this.extraKm;
    },
    getTotalCharges() {
      return this.isFreightBill ? this.totalAmountValue : this.invoiceCharges.totalAmount;
    },
    isValidGst() {
      return this.isReverseGstSelected || this.gstNumber;
    },
    checkStaticDiscount() {
      const staticDiscountvalue = this.invoiceCharges.additionalCharges.filter(val => val.label === 'discount'
      && val.percentage && val.amount);
      if (staticDiscountvalue && staticDiscountvalue.length) {
        return true;
      }
      return false;
    },
  },
  methods: {
    // updateGst(type, val) {
    //   if (this.canEditIgst) {
    //     if (type === 'igst') {
    //       this.$emit('updateValue', 'igst', val, 'manual_igst');
    //     } else if (type === 'cgst') {
    //       this.$emit('updateValue', 'igst', val * 2, 'manual_igst');
    //     }
    //   }
    // },
    displayDate(date) {
      let formattedDates = '';
      if (date) {
        formattedDates = formatDisplaySingleDate(date);
      }
      return formattedDates;
    },
    toggleMenu() {
      this.$emit('updateValue', 'payEarly', this.payEarly);
      this.calculateGst();
    },
    async calculateMininumDiscount() {
      try {
        const daysEarly = moment(this.futureDay).diff(moment(this.payByDate), 'days') + 1;
        const masterDiscountDetails = await this.$store.dispatch('paymentsV2/getBillDiscountMasterData', { days_early: daysEarly });
        const minDiscountRate = (masterDiscountDetails.data && masterDiscountDetails.data.discount_rate);
        this.minDiscountAmount = Number(((this.totalAmountValue / 100) * (minDiscountRate || 100)).toFixed(2));
        if (!minDiscountRate) {
          this.discountAmount = null;
        } else {
          this.discountAmount = this.billDiscountingConfig.hide_discount_amount ? null : this.minDiscountAmount;
        }
        this.$emit('updateValue', 'minDiscountAmount', this.minDiscountAmount);
        this.$emit('updateValue', 'discountAmount', this.discountAmount);
      } catch (error) {
        console.log(error);
      }
    },
    // eslint-disable-next-line func-names
    valuesChanged: debounce(async function ($event) {
      this.discountAmount = $event.target.value;
      this.$emit('updateValue', 'discountAmount', $event.target.value);
      if (this.discountAmount < this.totalAmountValue) {
        this.calculateGst();
      }
    }, 1000),
    calculateGst() {
      const discount = (this.payEarly && this.discountAmount) ? this.discountAmount : 0;
      let taxAmount = 0;
      if (this.isTaxable) {
        if (this.isIntraState) {
          this.invoiceCharges.cgstTaxAmount = (this.igst / 200) * (this.totalAmountValue - discount);
          this.invoiceCharges.sgstTaxAmount = (this.igst / 200) * (this.totalAmountValue - discount);
          taxAmount = this.invoiceCharges.cgstTaxAmount + this.invoiceCharges.sgstTaxAmount;
        } else {
          this.invoiceCharges.igstTaxAmount = (this.igst / 100) * (this.totalAmountValue - discount);
          taxAmount = this.invoiceCharges.igstTaxAmount;
        }
      }
      this.invoiceCharges.totalAmount = this.isFreightBill ? this.totalAmountValue : ((this.totalAmountValue - discount) + taxAmount);
    },
    updateGstNumberFromList(serviceProviderState) {
      this.$emit('updateValue', 'serviceProviderState', serviceProviderState);
      if (this.gstNumbers && this.gstNumbers.length) {
        const gst = this.gstNumbers.find(item => item.name === serviceProviderState);
        if (gst) {
          this.$emit('updateValue', 'gstNumber', gst.number);
          this.$emit('updateValue', 'gstAckNo', gst.ack_no);
          this.$emit('updateValue', 'gstAckDate', gst.ack_date);
          if (gst.gst_type != null) {
            this.$emit('updateValue', 'gstType', gst.gst_type);
          }
          if (gst.gst_percentage != null) {
            this.$emit('updateValue', 'igst', gst.gst_percentage);
          }
        }
      }
      this.calculateGst();
    },
    preventDefault(event) {
      event.stopPropagation();
    },
    updateExtraKm: debounce(function debounceExtraKm() {
      if (this.extraKmValue && this.extraKmValue >= 0) {
        this.$emit('updateExtraKm', this.extraKmValue);
      } else {
        this.$emit('updateExtraKm', 0);
      }
    }, 500),

    input($event) {
      const value = $event.target.value;
      this.extraKm = value;
    },
  },
};
</script>

<style scoped lang="scss" >
.arrow-active{
  background: rgba(36, 36, 47, 0.8);
}
</style>
